import { Box, Button, IconButton, Paper, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useOnboarding, OnboardingStep } from '../../../contexts/OnboardingContext';
import { CloseIcon } from '../../ui/icons';

interface OnboardingWelcomeModalProps {
  open: boolean;
  onClose: () => void;
}

const OnboardingWelcomeModal = ({ open, onClose }: OnboardingWelcomeModalProps) => {
  const { t } = useTranslation(['onboarding']);
  const theme = useTheme();
  const { startOnboarding, goToStep, skipOnboarding } = useOnboarding();

  const handleStartWithSampleData = () => {
    startOnboarding();
    goToStep(OnboardingStep.OVERVIEW_CHART);
    onClose();
  };

  const handleClose = () => {
    skipOnboarding();
    onClose();
  };

  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 56, // Above bottom navigation
        left: 0,
        right: 0,
        zIndex: theme.zIndex.modal,
        px: 2,
        pb: 2,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 2.5,
          borderRadius: 3,
          color: theme.palette.common.white,
          backgroundColor: theme.palette.pink[500],
          position: 'relative',
        }}
      >
        {/* Close button */}
        <IconButton
          onClick={handleClose}
          sx={{
            top: 8,
            right: 8,
            position: 'absolute',
            color: theme.palette.common.white,
          }}
        >
          <CloseIcon style={{ fontSize: 25 }} />
        </IconButton>

        {/* Content */}
        <Stack spacing={3}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ pr: 4 }}>
            <Typography variant="h6" component="span">
              🤖
            </Typography>
            <Typography
              variant="subtitle1"
            >
              {t('welcome_title')}
            </Typography>
          </Stack>

          <Typography style={{ marginTop: 8 }}>
            {t('welcome_description')}
          </Typography>

          <Stack alignItems="flex-end">
            <Button
              size="small"
              variant="contained"
              onClick={handleStartWithSampleData}
              sx={{
                px: 2
              }}
            >
              {t('view_sample_data')}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

export default OnboardingWelcomeModal;
